import { render, staticRenderFns } from "./HeaderDefault.vue?vue&type=template&id=5a3d8724&scoped=true&"
import script from "./HeaderDefault.vue?vue&type=script&lang=js&"
export * from "./HeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDefault.vue?vue&type=style&index=0&id=5a3d8724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d8724",
  null
  
)

export default component.exports